import { z } from 'zod';
/** Engine behaviour for one user: armed (copy buys + sells), buys paused (exits only), or fully off. */
export const BotState = {
    Off: 'off',
    Armed: 'armed',
    BuysPaused: 'buys_paused',
};
export const zBotState = z.enum([BotState.Off, BotState.Armed, BotState.BuysPaused]);
/** Arm the bot, pause new buys (exits keep running), or switch it off. */
export const zUpdateBotState = z.object({ state: zBotState });
export const zNotificationPrefs = z.object({
    email: z.object({
        /** Sign-ins from new devices, key exports, withdrawals, 2FA changes. Always on for exports/withdrawals. */
        security: z.boolean(),
        /** Bot auto-paused (loss limit, failures). */
        autoPause: z.boolean(),
        /** Every copy trade fill (noisy). */
        trades: z.boolean(),
    }),
    inApp: z.object({
        trades: z.boolean(),
        skips: z.boolean(),
        sound: z.boolean(),
    }),
});
export const DEFAULT_NOTIFICATION_PREFS = {
    email: { security: true, autoPause: true, trades: false },
    inApp: { trades: true, skips: false, sound: false },
};
export const zUpdateNotificationPrefs = zNotificationPrefs.partial().extend({
    email: zNotificationPrefs.shape.email.partial().optional(),
    inApp: zNotificationPrefs.shape.inApp.partial().optional(),
});
//# sourceMappingURL=users.js.map